/**
 * App environment config — single source of truth for env var access.
 * Vite replaces import.meta.env.* at build/dev time.
 * In tests, mock this module instead of polyfilling import.meta.
 */

export const IS_DEV = !!import.meta.env.DEV;

export const env = {
  REACT_APP_ENTRA_TENANT_ID: import.meta.env.REACT_APP_ENTRA_TENANT_ID || "",
  REACT_APP_ENTRA_CLIENT_ID: import.meta.env.REACT_APP_ENTRA_CLIENT_ID || "",
  REACT_APP_ENTRA_REDIRECT_URI: import.meta.env.REACT_APP_ENTRA_REDIRECT_URI || "",
  REACT_APP_CATALOG_URL: import.meta.env.REACT_APP_CATALOG_URL || "",
  REACT_APP_MARKETPLACE_NAME: import.meta.env.REACT_APP_MARKETPLACE_NAME || "skills-marketplace-catalog",
  REACT_APP_CATALOG_GIT_URL: import.meta.env.REACT_APP_CATALOG_GIT_URL || "https://ghe.coxautoinc.com/CoxAuto/skills-marketplace-catalog.git",
  REACT_APP_GITHUB_PROXY_URL: import.meta.env.REACT_APP_GITHUB_PROXY_URL || "",
  REACT_APP_NEWRELIC_ACCOUNT_ID: import.meta.env.REACT_APP_NEWRELIC_ACCOUNT_ID || "",
  REACT_APP_NEWRELIC_APPLICATION_ID: import.meta.env.REACT_APP_NEWRELIC_APPLICATION_ID || "",
  REACT_APP_NEWRELIC_LICENSE_KEY: import.meta.env.REACT_APP_NEWRELIC_LICENSE_KEY || "",
  REACT_APP_NEWRELIC_TRUST_KEY: import.meta.env.REACT_APP_NEWRELIC_TRUST_KEY || "",
  REACT_APP_NEWRELIC_CI_ID: import.meta.env.REACT_APP_NEWRELIC_CI_ID || "",
  REACT_APP_GTM_CONTAINER_ID: import.meta.env.REACT_APP_GTM_CONTAINER_ID || "",
};
